<template>
  <v-container>
    <v-card class="mx-auto" width="1000" height="350">
      <v-data-table
        :headers="headersHCPvsTest"
        :items="dataHCPvsTest"
        :search="search"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        class="elevation-1"
        @page-count="pageCount = $event"
        dense
      ></v-data-table>
      <div class="d-flex justify-space-between">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
        <router-link
          :to="{ path: '/pacientes/perfil/hcp/pruebas/correctores/01' }"
          style="text-decoration: none; color: inherit"
          class="d-flex justify-end"
        >
          <v-btn class="secundary2 white--text mr-4 my-2 text-capitalize"> HCP-002/CO-01 </v-btn>
        </router-link>
      </div>
      <div>
        <v-bottom-nav :btnNav="btnPatRecord" />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import VBottomNav from '@/components/base/VBottomNav.vue';

export default {
  name: 'VTableProPatientVersus',
  components: {
    VBottomNav,
  },
  props: ['headersHCPvsTest', 'dataHCPvsTest', 'btnPatRecord'],
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
};
</script>
